import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { getCurrentUser, getEndpoint } from 'src/app/core/services/functions.service';
import { AplicarRediferidoRequest, AplicarRediferidoResponse, CausalNoAceptacion, ClienteRediferidos, FacturaRediferido, NoAceptacionRediferidoRequest, NoAceptacionRediferidoResponse, Perfil, SimulacionCuota } from '../utils/perfil.model';
import { map } from 'rxjs/operators';
import { mapSimulacionCuota } from '../utils/map-simular-cuota';


@Injectable({
  providedIn: 'root'
})
export class RediferidosService {
  ENDPOINT = getEndpoint('rediferidos');

  constructor(private http: HttpClient) {}

  public getCompany(): string {
    return getCurrentUser()?.c_emp ?? 'JA';
  }

  buscarPerfilesActivos(): Observable<Perfil[]> {

    console.log("ENDPOINT",this.ENDPOINT);
    

    const url = `${this.ENDPOINT}/findallactivos`;
    const body = { c_emp: this.getCompany() };

    return this.http.post<any>(url, body).pipe(
      map(resp => (resp?.data || []).map((p: any): Perfil => ({
        cEmp: p.C_EMP,
        codPerfil: Number(p.COD_PERFIL),
        nombrePerfil: p.NOMBRE_PERFIL,
        tipoSimulacion: p.TIPO_SIMULACION,
        cuotaModificadora: Number(p.CUOTA_MODIFICADORA),
        cuotaIni: Number(p.CUOTA_INI),
        estado: p.ESTADO,
        usuario: p.USUARIO,
        tasa: Number(p.TASA),
        rediferidosPerfilDet: (p.REDIFERIDOSPERFILDET || []).map((d: any) => ({
          cEmp: d.C_EMP,
          codPerfil: Number(d.COD_PERFIL),
          cuotaIni: Number(d.CUOTA_INI)
        }))
      })))
    );
  }

  buscarCliente(documento: string): Observable<ClienteRediferidos> {
    const url = `${this.ENDPOINT}/findcliente`;

    return this.http.post<any>(url, {
      c_emp: this.getCompany(),
      n_ide: documento
    }).pipe(
      map(resp => this.mapCliente(resp.data))
    );
  }

  buscarFactura(cliente: ClienteRediferidos): Observable<FacturaRediferido[]> {
    const url = `${this.ENDPOINT}/findfacturas`;

    const body = {
      c_emp: this.getCompany(),
      n_ide: cliente.nIde,
      c_agr: cliente.cAgr,
      t_cre: cliente.tCre,
      cue: cliente.cue
    };

    return this.http.post<any>(url, body).pipe(
      map(resp =>
        (resp?.data || []).map((f: any) => ({
          factura: f.FACTURA,
          valor: Number(f.VALOR),
          fechaEmision: f.FECHA_EMISION,
          cuotasPendientes: Number(f.CUOTAS_PEN)
        }))
      )
    );
  }


  simularCuota(cliente: ClienteRediferidos,cuota: number,tasa: number): Observable<SimulacionCuota> {

    const url = `${this.ENDPOINT}/simularCuota`;

    const body = {
      c_emp: this.getCompany(),
      c_agr: cliente.cAgr,
      t_cre: cliente.tCre,
      cue: cliente.cue,
      n_ide: cliente.nIde,
      cuotas: cuota,
      tasa
    };

    return this.http.post<any>(url, body).pipe(
      map(resp => mapSimulacionCuota(resp.data))
    );
  }

  aplicarRediferido(body: AplicarRediferidoRequest): Observable<AplicarRediferidoResponse> {
    return this.http
      .post<AplicarRediferidoResponse>(`${this.ENDPOINT}/aplicar`, {
        c_emp: this.getCompany(),
        ...body
      })
      .pipe(
        map(resp => ({
          success: resp.success,
          message: resp.message
        }))
      );
    }

  noAceptarRediferido(
    body: NoAceptacionRediferidoRequest
  ): Observable<NoAceptacionRediferidoResponse> {
    return this.http.post<NoAceptacionRediferidoResponse>(
      `${this.ENDPOINT}/noaceptacion`,
      body
    );
  }

  buscarCausales(): Observable<CausalNoAceptacion[]> {
    const url = `${this.ENDPOINT}/findcausales`;

    return this.http.post<any>(url, { c_emp: this.getCompany() }).pipe(
      map(resp =>
        (resp?.data ?? []).map((item: any) => ({
          c_emp: item.C_EMP,
          cod_causal: item.COD_CAUSAL,
          nombre: item.NOMBRE
        }))
      )
    );
  }


  private mapCliente(c: any): ClienteRediferidos {
    if (!c) {
      throw new Error('Cliente no encontrado');
    }

    return {
      nIde: c.n_ide,
      nombreTitular: c.nombre_titular,
      cue: c.cue,
      cAgr: c.c_agr,
      tCre: c.t_cre,
      total: Number(c.total),
      saldo: Number(c.saldo),
      cuotaActual: Number(c.cuotaActual),
      saldoVencido: Number(c.saldo_venc),
      ageEst: c.age_est,
      estCred: c.est_cre
    };
  }
}

